<div class="separator-content mx-auto">
  <div class="intro-icon mb-4">
    <mat-icon svgIcon="separator_certificate_v2"></mat-icon>
  </div>
  <p translate>CERTIFICATE_SLIDE.CMI5_TERMINATION.TEXT</p>
</div>
